import React, { useEffect, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useAssetsApi } from "../../../store/api/hooks/assetsApiHook";
import { useAppLoader } from "../../../_common/pageLoader/appLoaderHook";
import Icon from "../../../components/icons";
import { Controller, useForm } from "react-hook-form";
import FileUpload from "../../../components/elements/form/fileUplaod";
import toast from "react-hot-toast";
import moment from "moment";
import { DATE_FORMAT } from "../../../_common/constant";
import { useDialog } from "../../../store/api/hooks/dialogHook";
import { useWorkRequestApi } from "../../../store/api/hooks/workRequestApiHook";
import Loader from "../../../components/loader";
import { showLocalDate } from "../../../_common/functions";
import { URLS } from "../../../_config";
import { titleCell } from "../../../components/elements/function";

interface Props {
    details: any
}
const ImpactedAsset: React.FC<Props> = ({ details }) => {
    const params: any = useParams();
    const assetsAPI = useAssetsApi();
    const workRequestAPI: any = useWorkRequestApi();

    const [gridApi, setGridApi] = useState<any>(null);
    const [attachmentList, setAttachmentList] = React.useState<any[]>([]);
    const { confirm } = useDialog();
    const [rowData, setRowData] = useState<any>(null);
    const [attachments, setAttachment] = useState<[]>([]);
    const { showLoader, hideLoader } = useAppLoader();
    let imgExt = ['.png', '.jpg', '.jpeg', '.webp'];
    const [columnDefs, setColumnDefs] = useState<any[] | null>(null);
    const { control, reset, handleSubmit, formState: { errors }, } = useForm<any>();
    const navigate = useNavigate();
    const deleteRow = (params: any) => {

        const rowId = params.data.assetID;
        console.log("fasfaf", params)


        const updatedData = rowData.filter((row: any) => row.assetID !== rowId);
        setRowData(updatedData);

    };
    useEffect(() => {
        setColumnDefs([

            { headerName: 'Asset ID', field: 'assetCode', headerClass: 'bg-[#f0f0f0]', width: 160 },
            {
                headerName: 'Asset Name', field: 'name', headerClass: 'bg-[#f0f0f0]', width: 300,
                cellRenderer: (data: any) => {
                    return (
                        <p className='hover:text-primary font-semibold cursor-pointer' title={data.value}>{data.value}</p>
                    )
                }, onCellClicked: (param: any) => {
                    navigate(URLS.ASSETS_DETAILS(param.data.assetID));
                }
            },
            { headerName: 'Category', field: 'categoryName', headerClass: 'bg-[#f0f0f0]', width: 160, cellRenderer: titleCell },
            { headerName: 'Facility Name', field: 'facilityName', headerClass: 'bg-[#f0f0f0]', flex: 1, minWidth: 160, cellRenderer: titleCell },
            {
                headerName: 'Status', field: 'statusName', headerClass: 'bg-[#f0f0f0]', width: 160, cellStyle: {
                    alignItems: 'center'
                }, cellRenderer: (data: any) => {
                    return (
                        <div className='flex items-center gap-2 h-full'>
                            <div className='w-[0.5rem] h-[0.5rem] rounded-full flex-shrink-0' style={{ backgroundColor: data.data.assetStatusColourCode || '#333333' }}></div>
                            <p className='text-[16px] text-[#755B51]'>{data.value}</p>
                        </div>
                    )
                },

            },


            {
                headerName: 'Warranty Expiry Date', field: 'warrantyEndDate', headerClass: 'bg-[#f0f0f0]', width: 200,
                cellRenderer: (data: any) => {
                    return (
                        <p className='hover:text-primary font-semibold cursor-pointer'>{showLocalDate(data.value)}</p>
                    )
                }
            },

        ])
    }, []);

    const getAttachmentList = (assetID: any) => {
        if (details?.workRequestMappingList) {
            const assetIds = details?.workRequestMappingList?.map((item: any) => item.assetID).join(',');
            let payload: any = {
                assetIDs: assetIds,
            };

            assetsAPI.getAssetsList(payload, (data: any) => {
                // Merge assetStatusColourCode from workRequestMappingList into asset data
                const mergedData = (data.assetList || []).map((asset: any) => {
                    const mappingData = details.workRequestMappingList.find((item: any) => item.assetID === asset.assetID);
                    return {
                        ...asset,
                        assetStatusColourCode: mappingData?.assetStatusColourCode || asset.assetStatusColourCode
                    };
                });
                setRowData(mergedData);
                console.log("data~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~", mergedData);
            }, (error: any) => {
                console.log("error", error);
            });
        } else {
            setRowData([]);
        }
    };

    useEffect(() => {
        if (params.id && details) {
            getAttachmentList(params.id);
        }
    }, [params, details]);


    return (
        <div className={`mt-3`}>
            <div className={`flex items-center justify-between items-center py-2 mb-0`}>
                <h4 className={`py-2 pl-1`} style={{ color: `#000`, fontWeight: `bold`, fontSize: 15 }}>Impacted Assets</h4>
            </div>
            <div className={``}>
                <AgGridReact
                    columnDefs={columnDefs} // Pass columnDefs
                    rowData={rowData} // Pass rowData
                    pagination={false}
                    //onGridReady={onGridReady}
                    //onRowClicked={onRowClicked}
                    domLayout="autoHeight"
                    loadingOverlayComponent={Loader}
                />
            </div>
        </div>
    );
};

export default ImpactedAsset;
